var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconStudent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2014_4733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1826 37.8508H5.08995C4.77183 37.8508 4.51734 37.8508 4.19922 37.9147C5.53532 38.8083 6.36243 40.021 6.36243 41.4253C6.36243 42.8296 5.53532 44.0423 4.19922 44.9359C4.45371 44.9998 4.77183 44.9998 5.08995 44.9998H42.1826C44.2822 44.9998 46 43.787 46 42.3189V40.4679C46 39.0636 44.2822 37.8508 42.1826 37.8508Z",
    fill: "#0054A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.67218 35.8726H34.4204C36.2019 35.8726 37.6653 34.1492 37.6653 31.979V29.2343C37.6653 27.1279 36.2019 25.3407 34.4204 25.3407H2.67218C2.41768 25.3407 2.16319 25.4045 1.90869 25.4684C3.05392 26.745 3.75378 28.596 3.75378 30.5747C3.75378 32.6173 3.05392 34.4045 1.90869 35.6811C2.16319 35.8088 2.41768 35.8726 2.67218 35.8726Z",
    fill: "#0054A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.165 22.085C41.165 22.4679 41.4832 22.8509 41.9285 22.8509H42.4375C42.8193 22.8509 43.201 22.5318 43.201 22.085V9.19135L41.2287 9.89347V22.085H41.165Z",
    fill: "#0054A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.183 23.1067C40.9106 23.1067 39.8926 25.3407 39.8926 28.0216H44.4735C44.4735 25.3407 43.4555 23.1067 42.183 23.1067Z",
    fill: "#0054A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97119 11.8723C8.97119 13.6595 8.97119 17.234 8.97119 17.2978C8.97119 21.3191 14.8882 23.0425 22.2686 23.0425C29.5853 23.0425 35.5023 21.2553 35.5023 17.2978C35.5023 17.1702 35.5023 16.5319 35.5023 16.2766V11.8085L22.2686 16.4042L8.97119 11.8723Z",
    fill: "#0054A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2047 15.0638L44.473 6.82979L21.8866 0L0 6.95745L22.2047 15.0638Z",
    fill: "#0054A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2014_4733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 45,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStudent);
export default __webpack_public_path__ + "static/media/iconStudent.f6fa2455f4da02739ae7033d1e82d415.svg";
export { ForwardRef as ReactComponent };